import { SourceTypes } from '../../../../constants';
import {
  getDataServicePage,
  getDataServicePostsFetcher,
  getDataServicePostsSelector,
  getPostsURL,
  getSourceStatusURL
} from '../../utils';
import type { ProviderType } from '../types';
import type { InstagramResponseType, InstagramSourceValue } from './types';

const PLATFORM = SourceTypes.INSTAGRAM;

export function createInstagramMentionsProvider(
  sourceValue: InstagramSourceValue,
  globalKey: string[],
  filtersKey: string[],
  widgetToken: string
): ProviderType<InstagramResponseType> {
  const {
    source = '',
    sourcePID = '',
    status,
    _customWidgetDataPostsLimit
  } = sourceValue;
  const key = [...globalKey, ...filtersKey, source, status];

  const statusURL = getSourceStatusURL(sourcePID);

  const postsURL = getPostsURL({
    sourcePID,
    limit: _customWidgetDataPostsLimit
  });

  const page = getDataServicePage(postsURL);

  const select = getDataServicePostsSelector({
    platform: PLATFORM,
    shouldUseUsername: true
  });

  const batchPostsFetch = getDataServicePostsFetcher({
    status,
    statusURL,
    postsURL,
    widgetToken,
    platform: PLATFORM
  });

  return { key, select, fetch: batchPostsFetch, page };
}
